import { useEffect, useMemo, useState } from "react";
import { JOURNAL_LANGS, LOCALES, makeT } from "./journalI18n";

export const useJournalLang = () => {
  const [lang, setLang] = useState(() => {
    const p = new URLSearchParams(window.location.search).get("lang");
    const stored = localStorage.getItem("vr_journal_lang");
    let v = (p || stored || "").toLowerCase();
    if (!v) {
      const cands = (navigator.languages || [navigator.language || "nl"]).map((x) => (x || "").slice(0, 2).toLowerCase());
      v = cands.find((c) => JOURNAL_LANGS.some((l) => l.code === c)) || "nl";
    }
    return JOURNAL_LANGS.some((l) => l.code === v) ? v : "nl";
  });
  useEffect(() => {
    localStorage.setItem("vr_journal_lang", lang);
    const url = new URL(window.location.href);
    if (lang === "nl") url.searchParams.delete("lang"); else url.searchParams.set("lang", lang);
    window.history.replaceState({}, "", url);
  }, [lang]);
  const t = useMemo(() => makeT(lang), [lang]);
  return { lang, setLang, t, locale: LOCALES[lang] || "nl-BE" };
};
